import styled from "styled-components";

export const Container = styled.div``;

export const Items = styled.ul`
  margin-left: 30px;

  li {
    margin-bottom: 15px;
  }

  :first-child {
    margin-left: 10px;
  }
`;
